<template>
  <v-container :fluid="true">
    <v-progress-linear v-show="loading" indeterminate color="yellow darken-2"
      style="margin-top:100px;"></v-progress-linear>
    <!-- SEARCH -->
    <v-btn v-show="!loading" id="btn-search-glo" class="btn-search-glo" @click="openSearch">
      <span class="material-icons-outlined">filter_alt</span>
    </v-btn>
    <v-row id="search" class="search">
      <v-btn class="btn-search-glo" @click="closeSearch">
        <span class="material-icons-outlined">close</span>
      </v-btn>
      <v-col style="margin-top: 10px;" cols="12" md="4">
        <label>Name Job</label>
        <v-autocomplete class="input none-input-details" v-model="selectedJob" :items="jobs"
          chips clearable deletable-chips multiple>
        </v-autocomplete>
      </v-col>
      <v-col style="margin-top: 10px;" cols="12" md="4">
        <label>Name Project</label>
        <v-autocomplete class="input none-input-details" v-model="selectedProject"
          :items="projects" chips clearable deletable-chips multiple>
        </v-autocomplete>
      </v-col>
      <v-col style="margin-top: 10px;" cols="12" md="4">
        <label>Name User</label>
        <v-autocomplete class="input none-input-details" v-model="selectedUser"
          :items="users" chips clearable deletable-chips multiple>
        </v-autocomplete>
      </v-col>

    </v-row>
    <v-btn v-show="!loading" id="btn-detail-glo" class="btn-detail-glo" @click="openDetail">
      <span class="material-icons-outlined">table_view</span>
    </v-btn>

    <!-- <v-row>
            <div class="bloc-recap-top" v-show="loading">
            LOADING
            <LoaderHomeRecap v-show="loading"/>
            </div>
        </v-row> -->
    <!-- BLOC RECAP -->
    <div id="bloc-recap" style="display: none;">
      <v-btn v-show="!loading" id="btn-detail-glo-close" class="btn-detail-glo" @click="closeDetail">
        <span class="material-icons-outlined">close</span>
      </v-btn>
      <ul id="bloc-recap-top" class="bloc-recap-top" v-show="!loading">
        <li>Projets <span class="num">{{ filteredProjects.length ? filteredProjects.length : '-' }}</span></li>
        <li>Jobs <span class="num">{{ filteredJobs.length ? filteredJobs.length : '-' }}</span></li>
        <li>Components <span class="num">{{ filteredComponents.length ? filteredComponents.length : '-' }}</span></li>
        <li>Routines <span class="num">{{ filteredRoutines.length ? filteredRoutines.length : '-' }}</span></li>
        <li>Metadata <span class="num">{{ filteredMetadatas.length ? filteredMetadatas.length : '-' }}</span></li>
        <li>Context group <span class="num">{{ filteredContextgroups.length ? filteredContextgroups.length : '-'
            }}</span>
        </li>
      </ul>
    </div>

    <!--<div id="btn-openList" @click="openList">
      <div class="keyboardComponent">
        <span class="material-icons-outlined keyboard">keyboard_double_arrow_right</span>
      </div>
    </div>
    <div id="btn-closeList" @click="closeList">
      <div class="keyboardComponent">
        <span class="material-icons-outlined keyboard">keyboard_double_arrow_left</span>
      </div>
    </div>
    
    <v-row style="margin-top: 8rem;">
      
      <v-col style="width: 49%; max-width: 49%;" id="list" v-show="kpisIsOpen" class="col">
        
        <div class="bloc-inner" v-for="(item, i) in seriesLine3" :key="i">
          <h3 class="subtitle">{{ item }}</h3>

          <apexchart type="line" height="142" :options="chartOptionsLine3" :series="seriesLine4(item)"></apexchart>
        </div>
      </v-col>
      
      <v-col :class="{ 'kpisClosed': !kpisIsOpen, 'kpisOpened': kpisIsOpen, 'search-active': isSearchActive, 'detail-active': isDetailActive }" class="col">
        
        <div class="bloc-inner" :class="{ 'bloc-kpisClosed': !kpisIsOpen, 'bloc-kpisOpened': kpisIsOpen }"
          v-show="!loading" style="width: 100%;">
          <h3 class="subtitle">Evolution du score</h3>
          <apexchart type="line" height="375" :options="chartOptionsLine2" :series="seriesLine2"></apexchart>
        </div>
        
        <div class="bloc-inner" :class="{ 'bloc-kpisClosed': !kpisIsOpen, 'bloc-kpisOpened': kpisIsOpen }"
          v-show="!loading">
          <h3 class="subtitle">Scoring par user</h3>
          <apexchart type="bar" height="375" :options="chartOptionsScoringUser" :series="seriesscoringUser"></apexchart>
        </div>

        
        <div class="bloc-inner" :class="{ 'bloc-kpisClosed': !kpisIsOpen, 'bloc-kpisOpened': kpisIsOpen }"
          v-show="!loading">
          <h3 class="subtitle">Scoring par projet</h3>
          <apexchart type="bar" height="375" :options="chartOptionsScoring" :series="seriesscoring"></apexchart>
        </div>

        <div class="bloc-inner" :class="{ 'bloc-kpisClosed': !kpisIsOpen, 'bloc-kpisOpened': kpisIsOpen }"
          v-show="!loading">
          <apexchart type="radar" height="350" :options="chartOptionsRadar" :series="seriesRadar"></apexchart>
        </div>

        <div class="bloc-inner" :class="{ 'bloc-kpisClosed': !kpisIsOpen, 'bloc-kpisOpened': kpisIsOpen }"
          v-show="!loading">
          <v-data-table class="mb-8" v-show="!loading" :headers="headerKpi" :items="docKpi">
            
            <template v-slot:item.value="{ item }">
              <div v-if="item.value === 1" style="background-color:orange; height: 30px; border-radius: 5px;"></div>
              <div v-else-if="item.value === 2" style="background-color:green; height: 30px; border-radius: 5px;"></div>
              <div v-else-if="item.value === 0" style="background-color:red; height: 30px; border-radius: 5px;"></div>
            </template>
          </v-data-table>
        </div>-->
        <!-- CUSTOMERS -->
        <!-- <div class="bloc-inner" v-show="!loading">
          <h3 class="subtitle">Component by type</h3>
          <div id="chart">
            <apexchart type="donut" height="265" :options="chartOptions" :series="series"></apexchart>
          </div>
          <DialogComponentType/>
        </div> -->

        <!-- <div class="bloc-recap" v-show="!loading">
          <h3 class="subtitle">
            <span class="material-icons orange">description</span>
            <span>{{ filledDocs }}% <br>Docs</span>
            </h3>

            
            <div class="docs" v-on:click="dialogJob = true">
              <div class="d-flex justify-space-between">
                <span>Doc Jobs</span>
                <span>{{ filledJobsDocs }}%</span>
              </div>
              <v-progress-linear
                  background-color="white"
                  color="orange"
                  rounded
                  :value="filledJobsDocs"
                  >
              </v-progress-linear>
            </div>
            <v-dialog
                v-model="dialogJob"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                >
              <v-card>
                <v-toolbar
                    class="dialog-header"
                    dark
                    flat
                    >
                  <h3 class="subtitle">
                    <span class="material-icons orange">description</span> <span>Doc Jobs</span>
                  </h3>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      dark
                      x-large
                      @click="dialogJob = false"
                      >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <div class="container">
                  <v-data-table
                      class="mb-8"
                      v-show="!loading"
                      :headers="headersdocjobs"
                      :items="docjobs"
                      :page.sync="pagedocjobs"
                      :items-per-page="10"
                      hide-default-footer
                      @page-count="pageCountdocjobs = $event"
                      :header-props="{ sortIcon: 'arrow_drop_down' }"
                      >
                  </v-data-table>
                  <v-pagination
                      v-model="pagedocjobs"
                      :length="pageCountdocjobs"
                      ></v-pagination>
                </div>
              </v-card>
            </v-dialog>

            <div class="docs" v-on:click="dialogRoutine = true">
              <div class="d-flex justify-space-between">
                <span>Doc Routines</span>
                <span>{{ filledRoutinesDocs }}%</span>
              </div>
              <v-progress-linear
                  background-color="white"
                  color="orange"
                  rounded
                  :value="filledRoutinesDocs"
                  >
              </v-progress-linear>
            </div>
            <v-dialog
                v-model="dialogRoutine"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                >
              <v-card>
                <v-toolbar
                    class="dialog-header"
                    dark
                    flat
                    >
                  <h3 class="subtitle">
                    <span class="material-icons orange">description</span> <span>Doc Routines</span>
                  </h3>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      dark
                      x-large
                      @click="dialogRoutine = false"
                      >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <div class="container">
                  <v-data-table
                      class="mb-8"
                      v-show="!loading"
                      :headers="headersdocroutines"
                      :items="docroutines"
                      :page.sync="pagedocroutines"
                      :items-per-page="10"
                      hide-default-footer
                      @page-count="pageCountdocroutines = $event"
                      :header-props="{ sortIcon: 'arrow_drop_down' }"
                      >
                  </v-data-table>
                  <v-pagination
                      v-model="pagedocroutines"
                      :length="pageCountdocroutines"
                      ></v-pagination>
                </div>
              </v-card>
            </v-dialog>

            <div class="docs" v-on:click="dialogJoblet = true">
              <div class="d-flex justify-space-between">
                <span>Doc Joblet</span>
                <span>{{ filledJobletsDocs }}%</span>
              </div>
              <v-progress-linear
                  background-color="white"
                  color="orange"
                  rounded
                  :value="filledJobletsDocs"
                  >
              </v-progress-linear>
            </div>
            <v-dialog
                v-model="dialogJoblet"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                >
              <v-card>
                <v-toolbar
                    class="dialog-header"
                    dark
                    flat
                    >
                  <h3 class="subtitle">
                    <span class="material-icons orange">description</span> <span>Doc Joblet</span>
                  </h3>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      dark
                      x-large
                      @click="dialogJoblet = false"
                      >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <div class="container">
                  <v-data-table
                      class="mb-8"
                      v-show="!loading"
                      :headers="headersdocjobs"
                      :items="docjoblets"
                      :page.sync="pagedocjoblets"
                      :items-per-page="10"
                      hide-default-footer
                      @page-count="pageCountdocjoblets = $event"
                      :header-props="{ sortIcon: 'arrow_drop_down' }"
                      >
                  </v-data-table>
                  <v-pagination
                      v-model="pagedocjoblets"
                      :length="pageCountdocjoblets"
                      ></v-pagination>
                </div>
              </v-card>
            </v-dialog>

            <div class="docs" v-on:click="dialogContext = true">
              <div class="d-flex justify-space-between">
                <span>Doc Context</span>
                <span>{{ filledContextgroupsDocs }}%</span>
              </div>
              <v-progress-linear
                  background-color="white"
                  color="orange"
                  rounded
                  :value="filledContextgroupsDocs"
                  >
              </v-progress-linear>
            </div>
            <v-dialog
                v-model="dialogContext"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                >
              <v-card>
                <v-toolbar
                    class="dialog-header"
                    dark
                    flat
                    >
                  <h3 class="subtitle">
                    <span class="material-icons orange">description</span> <span>Doc Context</span>
                  </h3>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      dark
                      x-large
                      @click="dialogContext = false"
                      >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <div class="container">
                  <v-data-table
                      class="mb-8"
                      v-show="!loading"
                      :headers="headersdocjobs"
                      :items="doccontext"
                      :page.sync="pagedoccontext"
                      :items-per-page="10"
                      hide-default-footer
                      @page-count="pageCountdoccontext = $event"
                      :header-props="{ sortIcon: 'arrow_drop_down' }"
                      >
                  </v-data-table>
                  <v-pagination
                      v-model="pagedoccontext"
                      :length="pageCountdoccontext"
                      ></v-pagination>
                </div>
              </v-card>
            </v-dialog>

            <div class="docs" v-on:click="dialogMetadata = true">
              <div class="d-flex justify-space-between">
                <span>Doc Metadata</span>
                <span>{{ filledMetadatasDocs }}%</span>
              </div>
              <v-progress-linear
                  background-color="white"
                  color="orange"
                  rounded
                  :value="filledMetadatasDocs"
                  >
              </v-progress-linear>
            </div>
            <v-dialog
                v-model="dialogMetadata"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar
                    class="dialog-header"
                    dark
                    flat
                    >
                  <h3 class="subtitle">
                    <span class="material-icons orange">description</span> <span>Doc Metadata</span>
                  </h3>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      dark
                      x-large
                      @click="dialogMetadata = false"
                      >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <div class="container">
                  <v-data-table
                      class="mb-8"
                      v-show="!loading"
                      :headers="headersdocjobs"
                      :items="docmetadata"
                      :page.sync="pagedocmetadata"
                      :items-per-page="10"
                      hide-default-footer
                      @page-count="pageCountdocmetadata = $event"
                      :header-props="{ sortIcon: 'arrow_drop_down' }"
                      >
                  </v-data-table>
                  <v-pagination
                      v-model="pagedocmetadata"
                      :length="pageCountdocmetadata"
                      ></v-pagination>
                </div>
              </v-card>
            </v-dialog>
        </div> -->
        <!-- JOBS IN ERROR -->
        <!-- <div class="bloc-inner" v-show="!loading">
            <div class="bloc-table">
                <h3 class="subtitle">
                <span class="material-icons red">error</span> <span><span
                    class="grey--text">{{ jobsInError.length }}</span><br> Jobs in error</span>
                </h3>

                <v-data-table
                    class="mb-8"
                    v-show="!loading"
                    :headers="headerserror"
                    :items="jobserror"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    @page-count="pageCount = $event"
                    :header-props="{ sortIcon: 'arrow_drop_down' }"
                >
                </v-data-table>

                <div class="d-flex pt-2">
                <v-pagination
                    v-model="page"
                    :length="pageCount"
                ></v-pagination>

                <DialogJobsError/>
                </div>
            </div>

            <div class="bloc-table" style="display: none">
                <h3 class="subtitle">
                <span class="material-icons blue">lock</span>
                <span><span class="grey--text">15</span><br> Jobs locked</span>
                </h3>

                <v-data-table
                    class="mb-8"
                    v-show="!loading"
                    :headers="headerslocked"
                    :items="jobslocked"
                    :page.sync="page2"
                    :items-per-page="itemsPerPage2"
                    hide-default-footer
                    @page-count="pageCount2 = $event"
                    :header-props="{ sortIcon: 'arrow_drop_down' }"
                >
                </v-data-table>

                <div class="d-flex pt-2">
                <v-pagination
                    v-model="page2"
                    :length="pageCount2"
                ></v-pagination>

                <v-btn
                    color="primary"
                    depressed
                    class="ml-auto"
                >
                    Display all
                </v-btn>
                </div>
            </div>

            <div class="bloc-table" v-if="'TAC' === admin">
                <h3 class="subtitle">
                <span class="material-icons green">hub</span>
                <span>TAC Configuration</span>
                </h3>

               

                <v-data-table
                    class="mb-8"
                    v-show="!loading"
                    :headers="headerstac"
                    :items="tac"
                    :items-per-page="itemsPerPage3"
                    :page.sync="page3"
                    hide-default-footer
                    @page-count="pageCount3 = $event"
                    :header-props="{ sortIcon: 'arrow_drop_down' }"
                >
                </v-data-table>

                <div class="d-flex pt-2">
                <v-pagination
                    v-model="page3"
                    :length="pageCount3"
                    :total-visible="10"
                ></v-pagination>
                </div>
            </div>
            </div> -->

        <!--<DialogJobsError/>-->
      <!--</v-col>
    </v-row>-->
  </v-container>
</template>

<script>
// import DoughnutChart from './DoughnutChart.js'
// import LoaderTree from '@/components/LoaderTree.vue'
// import LoaderHomeRecap from '@/components/LoaderHomeRecap.vue'
//  import LoaderHomeDatatable from '@/components/LoaderHomeDatatable.vue'
//  import DialogJobsError from '@/components/DialogJobsError.vue'
// import DialogComponentType from '@/components/DialogComponentType.vue'
// import Donut from '@/components/Donut.vue'
// import vuescroll from 'vuescroll'

// import { mapActions } from 'vuex'
import axios from "axios";
// import { cacheAdapterEnhancer } from 'axios-extensions';
// import LRUCache from 'lru-cache';
//import VueApexCharts from "vue3-apexcharts";

axios.defaults.baseURL = process.env.VUE_APP_API;

// let http;

export default {
  name: 'HomeView',

  components: {
    // DoughnutChart,
    // LoaderHomeRecap,
    //  LoaderHomeDatatable,
    // LoaderTree,
    // DialogJobsError,
    // DialogComponentType,
    //apexchart: VueApexCharts,
    // vuescroll
  },
  data() {
    return {
      isSearchActive: false,
      isDetailActive: false,
      kpisIsOpen: false,
      selectedJob: [],
      selectedProject: [],
      selectedUser: [],
      chartOptionsLine3: {
        chart: {
          id: 'tw',
          type: 'line',
          height: 142
        },
        xaxis: {
          labels: {
            show: false
          }
        },
        colors: ['#0D2498']
      },
      chartOptionsLine2: {
        chart: {
          id: 'tw',
          type: 'line',
          height: 142
        },
        xaxis: {
          labels: {
            show: false
          }
        },
        colors: ['#f94144ff', '#f3722cff', '#83D45Aff']
      },
      admin: '',
      dialogJob: false,
      dialogJoblet: false,
      dialogContext: false,
      dialogRoutine: false,
      dialogMetadata: false,
      headerKpi: [
        {
          title: 'Job',
          align: 'start',
          sortable: true,
          key: 'job',
        },
        { title: 'User', key: 'user' },
        { title: 'Score', key: 'value' },
        { title: 'Kpi', key: 'kpi' },
      ],
      score: {
        repository: {
          ps: {
            p: [{
              js: {
                j: []
              }
            }]
          }
        }
      },
      scoring: {
        repository: {
          ps: {
            p: [{
              js: {
                j: []
              }
            }]
          }
        }
      },
      scoringUsers: {
        repository: {
          us: {
            u: [{
              ps: {
                p: []
              }
            }]
          }
        }
      },
      kpis: {
        repository: {
          ps: {
            p: [{
              js: {
                j: []
              }
            }]
          }
        }
      },
      components_detail: {
        repository: {
          ps: {
            p: [{
              js: {
                j: []
              }
            }]
          }
        }
      },
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
        },
        labels: [],
        colors: ['#f94144ff', '#f3722cff', '#f8961eff', '#f9844aff', '#f9c74fff', '#90be6dff', '#43aa8bff', '#4d908eff', '#577590ff', '#277da1ff', '#f94144ff', '#f3722cff', '#f8961eff', '#f9844aff', '#f9c74fff', '#90be6dff', '#43aa8bff', '#4d908eff', '#577590ff', '#277da1ff', '#f94144ff', '#f3722cff', '#f8961eff', '#f9844aff', '#f9c74fff', '#90be6dff', '#43aa8bff', '#4d908eff', '#577590ff', '#277da1ff'],
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        stroke: {
          show: false,
        },
        pageCountKpi: 1,
        plotOptions: {
          pie: {
            donut: {
              size: '50%',
            }
          }
        },
      },
      tree: [],
      listrepository: {
        repository: {
          projects: []
        }
      },
      listusers: {
        repository: {
          us: {
            u: []
          }
        }
      },
      repositorydetail_jobs: {
        repository: {
          projects: [{
            jobs: []
          }]
        }
      },
      repositorydetail_routines: {
        repository: {
          projects: [{
            routines: []
          }]
        }
      },
      repositorydetail_joblets: {
        repository: {
          projects: [{
            joblets: []
          }]
        }
      },
      repositorydetail_contextgroup: {
        Repository: {
          projects: [{
            contextgroups: []
          }]
        }
      },
      repositorydetail_metadata: {
        Repository: {
          projects: [{
            metadatas: []
          }]
        }
      },
      infotac_conf: {
        tac: {
          sources: []
        }
      },
      tasksexecution: {
        tasks: {
          task: []
        }
      },
      // datatables
      pagedocjobs: 1,
      pageCountdocjobs: 1,
      pagedocroutines: 1,
      pageCountdocroutines: 1,
      pagedocjoblets: 1,
      pageCountdocjoblets: 1,
      pagedoccontext: 1,
      pageCountdoccontext: 1,
      pagedocmetadata: 1,
      pageCountdocmetadata: 1,
      page: 1,
      pageCount: 1,
      itemsPerPage: 5,
      page2: 1,
      pageCount2: 1,
      itemsPerPage2: 5,
      page3: 1,
      pageCount3: 1,
      itemsPerPage3: 5,
      headersdocjobs: [
        {
          text: 'Project',
          align: 'start',
          sortable: true,
          value: 'project',
        },
        { text: 'Job', value: 'job' },
        { text: 'Description', value: 'description' },
      ],
      headersdocroutines: [
        {
          text: 'Project',
          align: 'start',
          sortable: true,
          value: 'project',
        },
        { text: 'Routine', value: 'routine' },
        { text: 'Description', value: 'description' },
      ],
      headerserror: [
        {
          text: 'Label',
          align: 'start',
          sortable: true,
          value: 'label',
        },
        { text: 'Status', value: 'status' },
        { text: 'lastScriptGenerationDate', value: 'scriptdate' },
      ],
      headerslocked: [
        {
          text: 'Label',
          align: 'start',
          sortable: true,
          value: 'label',
        },
        { text: 'User', value: 'user' },
        { text: 'lastScriptGenerationDate', value: 'scriptdate' },
      ],
      headerstac: [
        {
          text: 'Module',
          align: 'start',
          sortable: true,
          value: 'module',
        },
        { text: 'Parameter', value: 'parameter' },
        { text: 'Value', value: 'value' },
      ],

      jobslocked: [
        {
          label: 'AUD_100_ALIMTACINFO',
          user: 'Hichem',
          scriptdate: '2021-06-11 19:14:59.806',
        },
        {
          label: 'AUD_301_ALIMELEMENTNODE',
          user: 'Philippe',
          scriptdate: '2021-06-11 19:16:58.755',
        },
        {
          label: 'AUD_308_ALIMCONNECTIONCOMPONENT',
          user: 'Delphine',
          scriptdate: '2021-06-11 19:14:59.806',
        },
        {
          label: 'AUD_100_ALIMTACINFO',
          user: 'Sam',
          scriptdate: '2021-06-11 19:14:59.806',
        },
        {
          label: 'AUD_301_ALIMELEMENTNODE',
          user: 'Nicolas',
          scriptdate: '2021-06-11 19:16:58.755',
        },
        {
          label: 'AUD_308_ALIMCONNECTIONCOMPONENT',
          user: 'Sandrine',
          scriptdate: '2021-06-11 19:14:59.806',
        },
        {
          label: 'AUD_100_ALIMTACINFO',
          user: 'Marceau',
          scriptdate: '2021-06-11 19:14:59.806',
        },
        {
          label: 'AUD_301_ALIMELEMENTNODE',
          user: 'David',
          scriptdate: '2021-06-11 19:16:58.755',
        },
        {
          label: 'AUD_308_ALIMCONNECTIONCOMPONENT',
          user: 'Micka',
          scriptdate: '2021-06-11 19:14:59.806',
        },
        {
          label: 'AUD_100_ALIMTACINFO',
          user: 'Yoo',
          scriptdate: '2021-06-11 19:14:59.806',
        },
      ],


      // loader
      loader: null,
      loading: false,
      // dialog
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      // datepicker
      // dates: ['2021-07-30', '2021-08-04'],
      menu: false,
      ops: null,
    }
  },
  computed: {
    docKpi() {
      return this.scoring ? this.scoring.repository.ps.p.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).flatMap(p => {
        return p.js.j.filter(e => this.selectedJob.length ? this.selectedJob.includes(e.jn) : true)
          .filter(u => this.selectedUser.length ? this.selectedUser.includes(u.u) : true)
          .flatMap(j => {
            return j.kpis.kpi.flatMap(k => ({
              job: j.jn,
              user: j.u,
              kpi: k.n,
              value: k.v
            }))
          })
      }) : []
    },
    scoringFlattened2() {
      return this.scoring ? this.scoring.repository.ps.p.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).flatMap(p => {
        return p.js.j.filter(e => this.selectedJob.length ? this.selectedJob.includes(e.jn) : true).filter(u => this.selectedUser.length ? this.selectedUser.includes(u.u) : true).flatMap(j => j)
      }) : []
    },
    scoringPercent() {
      return this.scoring ? this.scoring.repository.ps.p.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).map(p => {
        return {
          name: p.pn,
          ContextGroupRef: p.js.j.filter(u => this.selectedUser.length ? this.selectedUser.includes(u.u) : true).reduce((prev, curr) => {
            const t = curr.kpis.kpi.reduce((previousValue, currentValue) => {
              const cpt = currentValue.v === 2 ? 1 : 0
              return previousValue + cpt
            }, 0)
            return prev + t
          }, 0),
          ContextGroup: p.js.j.filter(u => this.selectedUser.length ? this.selectedUser.includes(u.u) : true).reduce((prev, curr) => {
            const t = curr.kpis.kpi.reduce((previousValue, currentValue) => {
              const cpt = currentValue.v === 0 ? 1 : 0
              return previousValue + cpt
            }, 0)
            return prev + t
          }, 0),
          buildin: p.js.j.filter(u => this.selectedUser.length ? this.selectedUser.includes(u.u) : true).reduce((prev, curr) => {
            const t = curr.kpis.kpi.reduce((previousValue, currentValue) => {
              const cpt = currentValue.v === 1 ? 1 : 0
              return previousValue + cpt
            }, 0)
            return prev + t
          }, 0)
        }
      }) : []
    },
    scoringPercentUser() {
      return this.scoringUsers ? this.scoringUsers.repository.us.u.filter(u => this.selectedUser.length ? this.selectedUser.includes(u.un) : true).map(u => {
        const ContextGroupRef = u.ps.p.flatMap(p => {
          return p.js.j.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).reduce((prev, curr) => {
            const t = curr.kpis.kpi.reduce((previousValue, currentValue) => {
              const cpt = currentValue.v === 2 ? 1 : 0;
              return previousValue + cpt;
            }, 0);
            return prev + t;
          }, 0);
        });

        const ContextGroup = u.ps.p.flatMap(p => {
          return p.js.j.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).reduce((prev, curr) => {
            const t = curr.kpis.kpi.reduce((previousValue, currentValue) => {
              const cpt = currentValue.v === 0 ? 1 : 0;
              return previousValue + cpt;
            }, 0);
            return prev + t;
          }, 0);
        });

        const buildin = u.ps.p.flatMap(p => {
          return p.js.j.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).reduce((prev, curr) => {
            const t = curr.kpis.kpi.reduce((previousValue, currentValue) => {
              const cpt = currentValue.v === 1 ? 1 : 0;
              return previousValue + cpt;
            }, 0);
            return prev + t;
          }, 0);
        });

        return {
          name: u.un,
          ContextGroupRef: ContextGroupRef.length > 0 ? ContextGroupRef[0] : 0,
          ContextGroup: ContextGroup.length > 0 ? ContextGroup[0] : 0,
          buildin: buildin.length > 0 ? buildin[0] : 0,
        };
      }) : [];
    },

    RadarCountKpisFlattened() {
      return this.scoring ? this.scoring.repository.ps.p
        .filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true)
        .flatMap(p => {
          return p.js.j
            .filter(e => this.selectedJob.length ? this.selectedJob.includes(e.jn) : true)
            .filter(e => this.selectedUser.length ? this.selectedUser.includes(e.u) : true)
            .flatMap(j => j.kpis.kpi.map(kpi => ({
              pn: p.pn,
              jn: j.jn,
              u: j.u,
              n: kpi.n,
              v: kpi.v
            })));
        }) : [];
    },

    RadarCountKpis() {
      if (!this.scoring) return [];

      // Créez un objet pour stocker le résumé par KPI
      const kpiSummary = {};

      // Filtrer les données en fonction des projets, emplois et utilisateurs sélectionnés
      const filteredData = this.RadarCountKpisFlattened;

      // Parcourez les données pour créer un résumé par KPI
      filteredData.forEach(r => {
        const kpiName = r.n; // Nom du KPI
        const kpiValue = r.v; // Valeur du KPI (0, 1 ou 2)

        if (!kpiSummary[kpiName]) {
          kpiSummary[kpiName] = {
            name: kpiName,
            nombreDeV0: 0,
            nombreDeV1: 0,
            nombreDeV2: 0
          };
        }

        // Incrémentez le total en fonction de la valeur du KPI
        if (kpiValue === 0) {
          kpiSummary[kpiName].nombreDeV0++;
        } else if (kpiValue === 1) {
          kpiSummary[kpiName].nombreDeV1++;
        } else if (kpiValue === 2) {
          kpiSummary[kpiName].nombreDeV2++;
        }
      });

      // Convertissez l'objet en un tableau d'objets
      const kpiArray = Object.values(kpiSummary);

      kpiArray.forEach(kpi => {
        const total = kpi.nombreDeV0 + kpi.nombreDeV1 + kpi.nombreDeV2;
        kpi.nombreDeV0 = Math.round((kpi.nombreDeV0 / total) * 100);
        kpi.nombreDeV1 = Math.round((kpi.nombreDeV1 / total) * 100);
        kpi.nombreDeV2 = Math.round((kpi.nombreDeV2 / total) * 100);
      });

      return kpiArray;
    },



    jobserror() {
      return this.tasksexecution.tasks.task.filter(j => (j.basicstatus && j.basicstatus === 'ERROR') || (j.executionStatus && j.executionStatus === 'DEPLOY_FAILED')).map(j => ({
        label: j.tasklabel ? j.tasklabel : j.taskname,
        status: j.detailedstatus ? j.detailedstatus : j.executionStatus,
        scriptdate: j.lastjobgenerationdate ? j.lastjobgenerationdate : j.finishTimestamp
      }))
    },
    docjobs() {
      return this.repositorydetail_jobs.repository.projects.flatMap(p => p.jobs.map(j => ({
        project: j.label,
        job: j.JOB_NAME,
        description: j.description
      })))
    },
    docroutines() {
      return this.repositorydetail_routines.repository.projects.flatMap(p => p.routines.map(j => ({
        project: j.label,
        routine: j.ROUTINE_NAME,
        description: j.description
      })))
    },
    docjoblets() {
      return this.repositorydetail_joblets.repository.projects.flatMap(p => p.joblets.map(j => ({
        project: j.label,
        joblet: j.JOBLET_NAME,
        description: j.description
      })))
    },
    doccontext() {
      return this.repositorydetail_contextgroup.Repository.projects.flatMap(p => p.contextgroups.map(j => ({
        project: j.label,
        job: j.CONTEXT_NAME,
        description: j.description
      })))
    },
    docmetadata() {
      return this.repositorydetail_metadata.Repository.projects.flatMap(p => p.metadatas.map(j => ({
        project: j.label,
        job: j.METADATA_NAME,
        description: j.description
      })))
    },
    tac() {
      return this.infotac_conf.tac.sources.flatMap(c => c.config.filter(co => co.recommandation).flatMap(co => ({
        module: c.source,
        parameter: co.parametre,
        value: co.valeur,
        recommandation: co.recommandation
      })))
    },
    // items() { return this.formatRepository(this.listrepository)},
    projects() {
      //console.log(this.listrepository.repository.projects)
      return this.listrepository.repository.projects
        .filter(r => this.selectedJob.length ? r.elements
          .some(e => this.selectedJob.includes(e.ELEMENT_NAME)) : true)
        .filter(r => this.selectedUser.length ? r.elements
          .some(e => this.selectedUser.includes(e.u)) : true)
        .map(r => r.AUD_LB_PROJECT_NAME)
    },

    jobs() {
      return this.listrepository.repository.projects.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.AUD_LB_PROJECT_NAME) : true).flatMap(r => {
        if (!Array.isArray(r.elements)) r.elements = [r.elements]
        return r.elements.filter(e => e.TYPE_ELEMENT === 'jobs').filter(e => this.selectedUser.length ? this.selectedUser.includes(e.u) : true).map(j => j.ELEMENT_NAME).sort((a, b) => a < b ? -1 : 1)
      })
    },
    users() {
      /*console.log(this.listusers.repository.us.u)*/
      return this.listusers.repository.us.u.map(r => r.un)
    },

    metadatas() {
      return this.listrepository.repository.projects.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.AUD_LB_PROJECT_NAME) : true)
        .filter(r => this.selectedJob.length ? r.elements
          .some(e => this.selectedJob.includes(e.ELEMENT_NAME)) : true).flatMap(r => {
            if (!Array.isArray(r.elements)) r.elements = [r.elements]
            return r.elements.filter(e => e.TYPE_ELEMENT === 'metadatas').filter(e => this.selectedUser.length ? this.selectedUser.includes(e.u) : true).map(j => ({
              id: j.ELEMENT_NAME,
              name: j.ELEMENT_NAME
            })).sort((a, b) => a.name < b.name ? -1 : 1)
          })
    },
    routines() {
      return this.listrepository.repository.projects.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.AUD_LB_PROJECT_NAME) : true)
        .filter(r => this.selectedJob.length ? r.elements
          .some(e => this.selectedJob.includes(e.ELEMENT_NAME)) : true).flatMap(r => {
            if (!Array.isArray(r.elements)) r.elements = [r.elements]
            return r.elements.filter(e => e.TYPE_ELEMENT === 'routines').filter(e => this.selectedUser.length ? this.selectedUser.includes(e.u) : true).map(j => ({
              id: j.ELEMENT_NAME,
              name: j.ELEMENT_NAME
            })).sort((a, b) => a.name < b.name ? -1 : 1)
          })
    },
    contextgroups() {
      return this.listrepository.repository.projects.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.AUD_LB_PROJECT_NAME) : true)
        .filter(r => this.selectedJob.length ? r.elements
          .some(e => this.selectedJob.includes(e.ELEMENT_NAME)) : true).flatMap(r => {
            if (!Array.isArray(r.elements)) r.elements = [r.elements]
            return r.elements.filter(e => e.TYPE_ELEMENT === 'contextgroup').filter(e => this.selectedUser.length ? this.selectedUser.includes(e.u) : true).map(j => ({
              id: j.ELEMENT_NAME,
              name: j.ELEMENT_NAME
            })).sort((a, b) => a.name < b.name ? -1 : 1)
          })
    },
    joblets() {
      return this.listrepository.repository.projects.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.AUD_LB_PROJECT_NAME) : true)
        .filter(r => this.selectedJob.length ? r.elements
          .some(e => this.selectedJob.includes(e.ELEMENT_NAME)) : true).flatMap(r => {
            if (!Array.isArray(r.elements)) r.elements = [r.elements]
            return r.elements.filter(e => e.TYPE_ELEMENT === 'joblets').filter(e => this.selectedUser.length ? this.selectedUser.includes(e.u) : true).map(j => ({
              id: j.ELEMENT_NAME,
              name: j.ELEMENT_NAME
            })).sort((a, b) => a.name < b.name ? -1 : 1)
          })
    },
    dateRangeText() {
      return '' //this.dates.join(' - ')
    },
    jobsInError() {
      return this.tasksexecution.tasks.task.filter(j => (j.basicstatus && j.basicstatus === 'ERROR') || (j.executionStatus && j.executionStatus === 'DEPLOY_FAILED'))
    },
    filteredProjects() {
      return this.projects.filter(e => this.selectedProject.length ? this.selectedProject.includes(e) : true)
    },
    filteredJobs() {
      return this.jobs.filter(e => this.selectedJob.length ? this.selectedJob.includes(e) : true)
    },
    filteredRoutines() {
      return this.routines
    },
    filteredJoblets() {
      return this.joblets
    },
    filteredMetadatas() {
      return this.metadatas
    },
    filteredContextgroups() {
      return this.contextgroups
    },
    filteredJobsDocs() {
      return this.repositorydetail_jobs.repository.projects.flatMap(p => p.jobs).filter(j => /*this.filteredJobs.map(j => j.id).includes(j.JOB_NAME) &&*/ j.description)
    },
    filledJobsDocs() {

      return this.filteredJobs.length ? Math.round((this.filteredJobsDocs.length / this.filteredJobs.length) * 100) : 0
    },
    filteredRoutinesDocs() {
      return this.repositorydetail_routines.repository.projects.flatMap(p => p.routines).filter(j => this.filteredRoutines.map(j => j.id).includes(j.ROUTINE_NAME) && j.description)
    },
    filledRoutinesDocs() {
      return this.filteredRoutines.length ? Math.round((this.filteredRoutinesDocs.length / this.filteredRoutines.length) * 100) : 0
    },
    filteredJobletsDocs() {
      return this.repositorydetail_joblets.repository.projects.flatMap(p => p.joblets).filter(j => this.filteredJoblets.map(j => j.id).includes(j.JOBLET_NAME) && j.description)
    },
    filledJobletsDocs() {
      return this.filteredJoblets.length ? Math.round((this.filteredJobletsDocs.length / this.filteredJoblets.length) * 100) : 0
    },
    filteredContextgroupsDocs() {
      return this.repositorydetail_contextgroup.Repository.projects.flatMap(p => p.contextgroups).filter(j => this.filteredContextgroups.map(j => j.id).includes(j.CONTEXT_NAME) && j.description)
    },
    filledContextgroupsDocs() {
      return this.filteredContextgroups.length ? Math.round((this.filteredContextgroupsDocs.length / this.filteredContextgroups.length) * 100) : 0
    },
    filteredMetadatasDocs() {
      return this.repositorydetail_metadata.Repository.projects.flatMap(p => p.metadatas).filter(j => this.filteredMetadatas.map(j => j.id).includes(j.METADATA_NAME) && j.description)
    },
    filledMetadatasDocs() {
      return this.filteredMetadatas.length ? Math.round((this.filteredMetadatasDocs.length / this.filteredMetadatas.length) * 100) : 0
    },
    filledDocs() {
      return Math.round((this.filledJobsDocs + this.filledRoutinesDocs + this.filledJobletsDocs + this.filledContextgroupsDocs + this.filledMetadatasDocs) / 5)
    },
    filteredComponents() {
      return this.components_detail.repository.ps.p.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).flatMap(p => {
        return p.js.j.filter(e => this.selectedJob.length ? this.selectedJob.includes(e.jn) : true).flatMap(j => {
          return j.cs
        })
      })
    },
    getterAllRepository() {
      return this.$store.getters.allRepository
    },
    repository() {
      return this.$store.state.repository
    },
    seriesLine2() {
      let r = [], d = [], u = [], z = []
      this.score.repository.ps.p
        .filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true)
        .forEach(pr => {
          pr.js.j.filter(e => this.selectedJob.length ? this.selectedJob.includes(e.jn) : true)
            .filter(u => this.selectedUser.length ? this.selectedUser.includes(u.u) : true)
            .forEach(jb => {
              jb.kpis.kpi.forEach(k => {
                if (!r[k.d]) r[k.d] = { zero: 0, one: 0, two: 0 }
                if (k.v == 0) r[k.d].zero++
                if (k.v == 1) r[k.d].one++
                if (k.v == 2) r[k.d].two++
              })
            })
        });
      for (const [key, value] of Object.entries(r)) {
        d.push({ x: key, y: value.two })
        u.push({ x: key, y: value.one })
        z.push({ x: key, y: value.zero })
      }
      return [{ name: 'Developpment quality no respected', data: z.sort((a, b) => a.x < b.x ? -1 : 1) }, { name: 'Developpment quality partially respected', data: u.sort((a, b) => a.x < b.x ? -1 : 1) }, { name: 'Developpment quality respected', data: d.sort((a, b) => a.x < b.x ? -1 : 1) }]
    },
    seriesLine3() {
      let r = []//, d = [], u = []
      this.kpis.repository.ps.p.filter(e => this.selectedProject.length ? this.selectedProject.includes(e.pn) : true).forEach(pr => {
        pr.js.j.filter(e => this.selectedJob.length ? this.selectedJob.includes(e.jn) : true).filter(u => this.selectedUser.length ? this.selectedUser.includes(u.u) : true).forEach(jb => {
          jb.kpis.kpi.forEach(k => {
            r.push(k.n)
          })
        })
      });
      return r.filter((v, i, s) => v && s.indexOf(v) === i)
    },
    seriesscoring() {
      return [
        {
          name: 'Developpment quality no respected',
          data: this.scoringPercent.map(t => t.ContextGroup)
        },
        {
          name: 'Developpment quality partially respected',
          data: this.scoringPercent.map(t => t.buildin)
        },
        {
          name: 'Developpment quality respected',
          data: this.scoringPercent.map(t => t.ContextGroupRef)
        }
      ]
    },
    seriesscoringUser() {
      return [
        {
          name: 'Developpment quality no respected',
          data: this.scoringPercentUser.map(t => t.ContextGroup)
        },
        {
          name: 'Developpment quality partially respected',
          data: this.scoringPercentUser.map(t => t.buildin)
        },
        {
          name: 'Developpment quality respected',
          data: this.scoringPercentUser.map(t => t.ContextGroupRef)
        }
      ]
    },
    seriesRadar() {
      return [
        {
          name: 'Developpment quality no respected',
          data: this.RadarCountKpis.map(t => t.nombreDeV0),
        },
        {
          name: 'Developpment quality partially respected',
          data: this.RadarCountKpis.map(t => t.nombreDeV1),
        },
        {
          name: 'Developpment quality respected',
          data: this.RadarCountKpis.map(t => t.nombreDeV2),
        }
      ]
    },
    chartOptionsRadar() {
      const categoryNames = this.RadarCountKpis.map(t => t.name);
      return {
        chart: {
          height: 350,
          type: 'radar',
          dropShadow: {
            enabled: true,
            blur: 1,
            left: 1,
            top: 1
          }
        },
        colors: ['#FF4560', '#EB7628', '#83D45A'],
        title: {
          text: 'Global scoring'
        },
        stroke: {
          width: 1
        },
        fill: {
          opacity: 0.1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "%"
            }
          },
          x: {
            formatter: function (val) {
              return categoryNames[val.index]; // Personnalisez ici le contenu de x
            }
          }
        },
        xaxis: {
          categories: this.RadarCountKpis.map((t, index) => ({
            index: index,
            value: t.name.slice(0, 3)
          })),
          labels: {
            formatter: function (val) {
              // Utilisez val.value pour obtenir le nom tronqué de la catégorie
              return val.value;
            }
          },
        },
        // yaxis: {
        //       tickAmount: 7,
        //       labels: {
        //         formatter: function(val, i) {
        //           if (i % 12 === 0) {
        //             return val
        //           } else {
        //             return ''
        //           }
        //         }
        //       }
        //     }
      }
    },
    chartOptionsScoring() {
      return {
        chart: {
          type: 'bar',
          height: 375,
          stacked: true,
          stackType: '100%',
          fontFamily: 'Roboto Condensed, sans-serif',
        },
        colors: ['#f94144ff', '#eb7628ff', '#83D45Aff'],
        plotOptions: {
          bar: {
            horizontal: false,
            barHeight: '96%',
            //columnWidth: '70%'
          },
        },
        grid: {
          borderColor: '#FFF',
        },
        title: {
          style: {
            fontSize: '16px',
            color: '#2B317C'
          },
        },
        xaxis: {
          categories: this.scoringPercent.map(t => t.name),
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          }
        },
        yaxis: {
          labels: {
            maxWidth: 160,
            style: {
              colors: "#2B317C",
              fontSize: '13px',
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " kpi" + (val > 1 ? "s" : "")
            }
          }
        },
        states: {
          hover: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'darken',
              value: 0.7,
            }
          },
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 130,
        },
      }
    },
    chartOptionsScoringUser() {
      return {
        chart: {
          type: 'bar',
          height: 375,
          stacked: true,
          stackType: '100%',
          fontFamily: 'Roboto Condensed, sans-serif',
        },
        colors: ['#f94144ff', '#eb7628ff', '#83D45Aff'],
        plotOptions: {
          bar: {
            horizontal: false,
            barHeight: '96%',
            //columnWidth: '70%'
          },
        },
        grid: {
          borderColor: '#FFF',
        },
        title: {
          style: {
            fontSize: '16px',
            color: '#2B317C'
          },
        },
        xaxis: {
          categories: this.scoringPercentUser.map(t => t.name),
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          }
        },
        yaxis: {
          labels: {
            maxWidth: 160,
            style: {
              colors: "#2B317C",
              fontSize: '13px',
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " kpi" + (val > 1 ? "s" : "")
            }
          }
        },
        states: {
          hover: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'darken',
              value: 0.7,
            }
          },
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 130,
        },
      }
    },
  },
  // btn loader
  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
  },
  methods: {
    getColorStyle(value) {
      if (value === 1) {
        return { 'background-color': 'orange' };
      } else if (value === 2) {
        return { 'background-color': 'red' };
      } else {
        return {};
      }
    },
    openList: function () {
      this.kpisIsOpen = true
      document.getElementById("list").style.display = "block";
      document.getElementById("btn-openList").style.display = "none";
      document.getElementById("btn-closeList").style.display = "block";
    },
    closeList: function () {
      this.kpisIsOpen = false
      document.getElementById("list").style.display = "none";
      document.getElementById("btn-openList").style.display = "block";
      document.getElementById("btn-closeList").style.display = "none";
    },
    openSearch() {
      document.getElementById("search").style.display = "flex";
      document.getElementById("btn-search-glo").style.display = "none";
      document.getElementById("btn-detail-glo").style.top = "125px";
      document.getElementById("btn-detail-glo-close").style.top = "125px";
      document.getElementById("bloc-recap-top").style.top = "165px";
      this.isSearchActive = !this.isSearchActive; 
    },
    closeSearch() {
      document.getElementById("search").style.display = "none";
      document.getElementById("btn-search-glo").style.display = "block";
      document.getElementById("btn-detail-glo").style.top = "56px";
      document.getElementById("btn-detail-glo-close").style.top = "56px";
      document.getElementById("bloc-recap-top").style.top = "98px";
      this.isSearchActive = !this.isSearchActive; 
    },
    openDetail() {
      document.getElementById("bloc-recap").style.display = "block";
      document.getElementById("btn-detail-glo").style.display = "none";
      this.isDetailActive = !this.isDetailActive; 
    },
    closeDetail() {
      document.getElementById("bloc-recap").style.display = "none";
      document.getElementById("btn-detail-glo").style.display = "block";
      this.isDetailActive = !this.isDetailActive; 
    },
    seriesLine4(kpi) {
      let r = [], d = [], u = []
      this.kpis.repository.ps.p.forEach(pr => {
        pr.js.j.filter(j => this.tree.length ? this.tree.includes('j_' + j.jn) : true).forEach(jb => {
          jb.kpis.kpi.forEach(k => {
            r.push(k.n)
            if (k.n == kpi) {
              k.vs.forEach(v => {
                if (!d[v.d]) d[v.d] = 0
                d[v.d] += v.v
              })
            }
          })
        })
      });
      for (const [key, value] of Object.entries(d)) {
        u.push({ x: key, y: value })
      }
      return [{ name: kpi, data: u.sort((a, b) => a.x < b.x ? -1 : 1) }]
    },
    normalizeKpi(kpi) {
      if (kpi && !Array.isArray(kpi.repository.ps.p)) {
        kpi.repository.ps.p = [kpi.repository.ps.p]
      }
      kpi.repository.ps.p.forEach(p => {
        if (!Array.isArray(p.js.j)) {
          p.js.j = [p.js.j]
        }
        p.js.j.forEach(j => {
          if (!Array.isArray(j.cs)) j.cs = [j.cs]
        })
      })

      return kpi
    },
    normalizeKpiScoring(kpi) {
      if (!kpi.repository.ps) return kpi
      if (Array.isArray(kpi.repository.ps)) {
        kpi.repository.ps.p = kpi.repository.ps
      }
      if (kpi && !Array.isArray(kpi.repository.ps.p)) {
        kpi.repository.ps.p = [kpi.repository.ps.p]
      }
      kpi.repository.ps.p.forEach(p => {
        if (Array.isArray(p.js)) {
          p.js.j = p.js
        }
        if (!Array.isArray(p.js.j)) {
          p.js.j = [p.js.j]
        }
        p.js.j.forEach(j => {
          if (!j || !j.kpis) return j
          if (Array.isArray(j.kpis)) {
            j.kpis.kpi = j.kpis
          }
          if (!Array.isArray(j.kpis.kpi)) {
            j.kpis.kpi = [j.kpis.kpi]
          }
          j.kpis.kpi.forEach(k => {
            if (!Array.isArray(k.vs)) {
              k.vs = [k.vs]
            }
          })
        })
      })

      return kpi
    },
    normalizeKpiScoringUsers(kpi) {
      if (kpi && !Array.isArray(kpi.repository.us.u)) {
        kpi.repository.us.u = [kpi.repository.us.u]
      }
      kpi.repository.us.u.forEach(u => {
        if (!Array.isArray(u.ps.p)) {
          u.ps.p = [u.ps.p]
        }
        u.ps.p.forEach(p => {
          if (!Array.isArray(p.js.j)) {
            p.js.j = [p.js.j]
          }
          p.js.j.forEach(j => {
            if (!Array.isArray(j.kpis.kpi)) {
              j.kpis.kpi = [j.kpis.kpi]
            }
          })
        })
      })

      return kpi
    },
    normalizeRepository(kpi) {
      if (kpi && kpi.repository) {
        if (kpi.repository.projects && !Array.isArray(kpi.repository.projects)) {
          kpi.repository.projects = [kpi.repository.projects]
        }
        kpi.repository.projects.forEach(p => {
          if (p.jobs && !Array.isArray(p.jobs)) {
            p.jobs = [p.jobs]
          }
          if (p.routines && !Array.isArray(p.routines)) {
            p.routines = [p.routines]
          }
          if (p.joblets && !Array.isArray(p.joblets)) {
            p.joblets = [p.joblets]
          }
          if (p.contextgroups && !Array.isArray(p.contextgroups)) {
            p.contextgroups = [p.contextgroups]
          }
          if (p.metadatas && !Array.isArray(p.metadatas)) {
            p.metadatas = [p.metadatas]
          }
        })
      }
      return kpi
    },
    normalizeRepositoryCaps(kpi) {
      if (kpi && kpi.Repository) {
        if (kpi.Repository.projects && !Array.isArray(kpi.Repository.projects)) {
          kpi.Repository.projects = [kpi.Repository.projects]
        }
        kpi.Repository.projects.forEach(p => {
          if (p.jobs && !Array.isArray(p.jobs)) {
            p.jobs = [p.jobs]
          }
          if (p.routines && !Array.isArray(p.routines)) {
            p.routines = [p.routines]
          }
          if (p.joblets && !Array.isArray(p.joblets)) {
            p.joblets = [p.joblets]
          }
          if (p.contextgroups && !Array.isArray(p.contextgroups)) {
            p.contextgroups = [p.contextgroups]
          }
          if (p.metadatas && !Array.isArray(p.metadatas)) {
            p.metadatas = [p.metadatas]
          }
        })
      }
      return kpi
    },
    filter() {
      this.loader = 'loading'
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    formatRepository(data) {
      return data ? data.repository.projects.map((r, idx) => {
        if (!Array.isArray(r.elements)) {
          r.elements = [r.elements]
        }
        return {
          id: 'p_' + r.AUD_LB_PROJECT_NAME,
          name: r.AUD_LB_PROJECT_NAME,
          children: [
            {
              id: 'j' + idx, name: 'Jobs',
              children: r.elements.filter(e => e.TYPE_ELEMENT === 'jobs').map(j => ({
                id: 'j_' + j.ELEMENT_NAME,
                name: j.ELEMENT_NAME
              })).sort((a, b) => a.name < b.name ? -1 : 1),
            },
            {
              id: 'm' + idx, name: 'Metadata',
              children: r.elements.filter(e => e.TYPE_ELEMENT === 'metadatas').map(j => ({
                id: 'm_' + j.ELEMENT_NAME,
                name: j.ELEMENT_NAME
              })).sort((a, b) => a.name < b.name ? -1 : 1),
            },
            {
              id: 'r' + idx, name: 'Routines',
              children: r.elements.filter(e => e.TYPE_ELEMENT === 'routines').map(j => ({
                id: 'r_' + j.ELEMENT_NAME,
                name: j.ELEMENT_NAME
              })).sort((a, b) => a.name < b.name ? -1 : 1),
            },
            {
              id: 'jo' + idx, name: 'Joblets',
              children: r.elements.filter(e => e.TYPE_ELEMENT === 'joblets').map(j => ({
                id: 'jo_' + j.ELEMENT_NAME,
                name: j.ELEMENT_NAME
              })).sort((a, b) => a.name < b.name ? -1 : 1),
            },
            {
              id: 'c' + idx, name: 'Contextgroup',
              children: r.elements.filter(e => e.TYPE_ELEMENT === 'contextgroup').map(j => ({
                id: 'c_' + j.ELEMENT_NAME,
                name: j.ELEMENT_NAME
              })).sort((a, b) => a.name < b.name ? -1 : 1),
            },
          ]
        }
      }) : []
    },
  },
  created() {
    this.loading = true
    Promise.all([
      axios.get("", { params: { endpoint: "repository/listrepository" } }),
      axios.get("", { params: { endpoint: "components/listcomponentsdetail" } }),
      axios.get("", { params: { endpoint: "repository/users" } }),
      axios.get("", { params: { endpoint: "repositorydetail/jobs" } }),
      axios.get("", { params: { endpoint: "repositorydetail/routines" } }),
      axios.get("", { params: { endpoint: "repositorydetail/joblets" } }),
      axios.get("", { params: { endpoint: "repositorydetail/contextgroup" } }),
      axios.get("", { params: { endpoint: "repositorydetail/metadata" } }),
      axios.get("", { params: { endpoint: "tac/conf", verb: "POST", "data-raw": '{"cle":"","is_recommanded":"","source":""}' } }),
      axios.get("", { params: { endpoint: "tasksexecution" } }),
      axios.get("", { params: { endpoint: "admin" } }),
      axios.get("", { params: { endpoint: "histo/score" } }),
      axios.get("", { params: { endpoint: "histo/kpis" } }),
      axios.get("", { params: { endpoint: "histo/lastscore" } }),
      axios.get("", { params: { endpoint: "histo/lastscoreusers" } })
    ])
      .then(([listrepository, components_detail, listusers, repositorydetail_jobs, repositorydetail_routines, repositorydetail_joblets, repositorydetail_contextgroup, repositorydetail_metadata, infotac_conf,
        tasksexecution, admin, score, kpis, lastscore, lastscoreusers]) => {
        // listrepository
        //console.log(listrepository.data[0].repository)
        if (listrepository.data[0].repository) {

          if (!Array.isArray(listrepository.data[0].repository.projects)) this.listrepository.repository.projects = [listrepository.data[0].repository.projects]
          else this.listrepository.repository.projects = listrepository.data[0].repository.projects
        }
        if (listusers.data[0].repository) {
          if (!Array.isArray(listusers.data[0].repository.us.u)) this.listusers.repository.us.u = [listusers.data[0].repository.us.u]
          else this.listusers.repository.us.u = listusers.data[0].repository.us.u
        }


        // components_detail
        if (components_detail.data.repository) {
          this.components_detail = this.normalizeKpi(components_detail.data)
          this.series = (array => {
            const r = [], o = {};
            array.forEach(a => {
              if (!o[a.catl]) {
                o[a.catl] = { label: a.catl, value: 0 };
                r.push(o[a.catl]);
              }
              o[a.catl].value++;
            });
            return r;
          })(this.components_detail.repository.ps.p.flatMap(p => p.js.j.flatMap(r => r.cs))).map(c => c.value)
          this.chartOptions = {
            labels: (array => {
              const r = [], o = {};
              array.forEach(a => {
                if (!o[a.catl]) {
                  o[a.catl] = { label: a.catl, value: 0 };
                  r.push(o[a.catl]);
                }
                o[a.catl].value++;
              });
              return r;
            })(this.components_detail.repository.ps.p.flatMap(p => p.js.j.flatMap(r => r.cs))).map(c => c.label)
          }
        }

        // repositorydetail_jobs
        if (repositorydetail_jobs.data.repository) {
          this.repositorydetail_jobs = this.normalizeRepository(repositorydetail_jobs.data)
        }
        if (score.data[0].repository) {
          this.score = this.normalizeKpiScoring(score.data[0])
        }
        if (lastscore.data[0].repository) {
          this.scoring = this.normalizeKpiScoring(lastscore.data[0])
        }
        if (lastscoreusers.data[0].repository) {
          this.scoringUsers = this.normalizeKpiScoringUsers(lastscoreusers.data[0])
        }
        if (kpis.data[0].repository) {
          this.kpis = this.normalizeKpiScoring(kpis.data[0])
        }

        // repositorydetail_routines
        if (repositorydetail_routines.data.repository) {
          this.repositorydetail_routines = this.normalizeRepository(repositorydetail_routines.data)
        }

        // repositorydetail_joblets
        if (repositorydetail_joblets.data.repository) {
          this.repositorydetail_joblets = this.normalizeRepository(repositorydetail_joblets.data)
        }

        // repositorydetail_contextgroup
        if (repositorydetail_contextgroup.data.Repository) {
          this.repositorydetail_contextgroup = this.normalizeRepositoryCaps(repositorydetail_contextgroup.data)
        }

        // repositorydetail_metadata
        if (repositorydetail_contextgroup.data.Repository) {
          this.repositorydetail_metadata = this.normalizeRepositoryCaps(repositorydetail_metadata.data)
        }

        // infotac_conf
        if (infotac_conf.data && 'TAC' === admin.data.root.admin) {
          if (!Array.isArray(infotac_conf.data.tac.sources)) this.infotac_conf.tac.sources = [infotac_conf.data.tac.sources]
          else this.infotac_conf.tac.sources = infotac_conf.data.tac.sources
        }

        // tasksexecution
        if (tasksexecution.data.tasks) {
          if (!Array.isArray(tasksexecution.data.tasks.task)) this.tasksexecution.tasks.task = [tasksexecution.data.tasks.task]
          else this.tasksexecution.tasks.task = tasksexecution.data.tasks.task
        }

        // admin
        this.admin = admin.data.root.admin

        // loader
        this.loading = false
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      });
  }
}
</script>

<style lang="scss" scoped>
.search {
  display: none;
  position: fixed;
  z-index: 998;
  margin: auto;
  right: 0;
  width: 92%;
}

.search-active {
  margin-top: 70px;
}

.detail-active{
  margin-top: 130px;
}

.input {
    border: 0.1px solid transparent;  
    min-height: 55px;
}

.kpisClosed {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}

.kpisOpened {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}

.bloc-kpisClosed {
  width: 49%;
  transition: width 0.3s ease;
}

.bloc-kpisOpened {
  width: 100%;
  transition: width 0.3s ease;
}

#btn-openList {
  z-index: 2;
  position: fixed;
  left: 56px;
  top: 50%;
  background-color: #E85C18;
  margin: auto;
  border-radius: 0 10px 10px 0;
  width: 20px;
  min-width: auto;
  height: 55px;
}

#btn-closeList {
  z-index: 2;
  display: none;
  position: fixed;
  left: 56px;
  top: 50%;
  background-color: #E85C18;
  margin: auto;
  border-radius: 0 10px 10px 0;
  width: 20px;
  min-width: auto;
  height: 55px;
}

#btn-openList :hover {
  cursor: pointer;
}

#btn-closeList :hover {
  cursor: pointer;
}

.btn-search-glo {
  z-index: 998;
  position: fixed;
  right: 12px;
  color: white;
  background: #E85C18;
}

.keyboard {
  color: white;
  font-size: 20px;
}

.keyboardComponent {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.col {
  padding-top: 2.5rem;
}

.border {
    border-top: 1px solid rgba(128, 128, 128, 0.2) !important;
    border-left: 1px solid rgba(128, 128, 128, 0.2) !important;
    border-right: 1px solid rgba(128, 128, 128, 0.2) !important;
  }
</style>
